<template>
	<div class="report_list_card">
		<div
			v-for="(item,index) in list"
			:key="index"
			class="report_list_card_item"
			:class="{'card_pripary':index === 0}"
		>
			<div class="header">
				<div class="round"></div>
				<div class="text">{{ item.date }}</div>
			</div>
			<div class="content">
				<div class="content_item" v-for="report in item.list" :key="report.id" @click="goDetail(report)">
					<div
						class="tag"
						:class="{
                            'purple_tag':report.dateType === 1
                        }"
					>
						{{report.dateType === 1?'月报':'周报'}}
					</div>
					<div class="text" v-if="report.dateType === 1">
						{{ $moment(report.startTime).format('M月月报') }}
					</div>
					<div class="text" v-else>
						{{ $moment(report.startTime).format('M月DD日') }}
						-
						{{ $moment(report.endTime).format('M月DD日') }}
					</div>
					<div class="icon"><van-icon name="arrow" /></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
    name: 'reportListCard',
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        goDetail (item) {
            this.$router.push({
                path: `/report/detail/${item.id}`
            })
        }
    }
}
</script>

<style lang="less" scoped>
@gary: #bbbfc4;
@purple: #6852eb;
.report_list_card {
	&_item {
		border-left: 2px solid @gary;
		position: relative;
		.header {
			position: absolute;
			display: flex;
			align-items: center;
			height: 62px;
			top: -32px;
			left: -12px;
			.round {
				width: 24px;
				height: 24px;
				border-radius: 12px;
				background-color: @gary;
				margin-right: 32px;
			}
			.text {
				color: #8f959e;
				font-size: 40px;
				font-weight: bold;
			}
		}
		.content {
			padding: 64px 0 28px 43px;
			&_item {
				display: flex;
				align-content: center;
				font-size: 36px;
				color: #1f2329;
				font-weight: bold;
				padding: 33px 32px;
				height: 47px;
				line-height: 47px;
				background-color: #ffffff;
				border-radius: 20px;
				margin-bottom: 24px;
				.tag {
					font-size: 28px;
					color: #ffffff;
					width: 80px;
					text-align: center;
					border-radius: 10px;
					background-color: @primary;
					margin-right: 16px;
				}
				.purple_tag {
					background-color: @purple;
				}
				.text {
					flex: 1;
				}
				.icon {
					color: #bbbfc4;
				}
			}
		}
		&:last-child {
			border-left: none !important;
		}
	}

	.card_pripary {
		border-left: 2px solid @primary;
		.round {
			background-color: @primary;
		}
		.text {
			color: #1f2329;
		}
	}
}
</style>